import styled from 'styled-components';

export const Wrapper = styled.div`
  flex: 1;
  background: radial-gradient(circle, rgb(14, 33, 88), rgb(6, 13, 34));
  display: flex;
`;
